export const truncateWords = (sentence: string, num: number) => {
  const words = sentence.split(" ")
  if (words.length <= num) return sentence
  return words.slice(0, num).join(" ") + "..."
}

export const truncateByCharToNearestWord = (sentence: string, num: number) => {
  if (sentence.length <= num) return sentence
  const words = sentence.split(" ")
  let truncatedSentence = words[0]
  for (let i = 1; i < words.length; i++) {
    if (truncatedSentence.length + words[i].length + 1 <= num) {
      truncatedSentence += " " + words[i]
    } else {
      break
    }
  }
  return truncatedSentence + "..."
}

export const truncateWithHtmlByCharacters = (
  html: string,
  maxChars: number,
): string => {
  const parser = new DOMParser()
  const doc = parser.parseFromString(html, "text/html")
  const body = doc.body

  let charCount = 0
  let lastSpaceIndex = -1
  let resultAtLastSpace = ""
  let truncatedHtml = ""

  const truncateNode = (node: Node): { html: string; done: boolean } => {
    let result = ""

    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.nodeValue || ""
      for (let i = 0; i < text.length && charCount < maxChars; i++) {
        const char = text[i]
        result += char
        charCount++
        if (char === " ") {
          lastSpaceIndex = charCount
          resultAtLastSpace = result
        }
      }

      if (charCount >= maxChars) {
        if (lastSpaceIndex !== -1) {
          result = resultAtLastSpace
        }
        return { html: result, done: true }
      }
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      const element = node as Element
      const tagName = element.tagName.toLowerCase()

      result += `<${tagName}`

      for (const attr of Array.from(element.attributes)) {
        result += ` ${attr.name}="${attr.value}"`
      }

      // Check for void/self-closing elements like <br>, <img>, etc.
      const voidElements = [
        "area",
        "base",
        "br",
        "col",
        "embed",
        "hr",
        "img",
        "input",
        "link",
        "meta",
        "param",
        "source",
        "track",
        "wbr",
      ]

      if (voidElements.includes(tagName)) {
        result += ">"
        return { html: result, done: false }
      } else {
        result += ">"

        // Process children for non-void elements
        for (const child of Array.from(element.childNodes)) {
          const { html: childHtml, done } = truncateNode(child)
          result += childHtml

          if (done) {
            result += `</${tagName}>`
            return { html: result, done: true }
          }
        }
      }

      result += `</${tagName}>`
    }

    return { html: result, done: false }
  }

  for (const child of Array.from(body.childNodes)) {
    const { html, done } = truncateNode(child)
    truncatedHtml += html

    if (done) {
      break
    }
  }

  return truncatedHtml
}
